import { render, staticRenderFns } from "./AtuationAreaSelect.vue?vue&type=template&id=677997b8"
import script from "./AtuationAreaSelect.vue?vue&type=script&lang=js"
export * from "./AtuationAreaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports